import createIcon from '../../createIcon';

/**
 * @component @name ViewWeek
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS4zMyAyMEg0QzIuOSAyMCAyIDE5LjEgMiAxOFY2QzIgNC45IDIuOSA0IDQgNEg1LjMzQzYuNDMgNCA3LjMzIDQuOSA3LjMzIDZWMThDNy4zMyAxOS4xIDYuNDQgMjAgNS4zMyAyMFpNMjIgMThWNkMyMiA0LjkgMjEuMSA0IDIwIDRIMTguNjdDMTcuNTcgNCAxNi42NyA0LjkgMTYuNjcgNlYxOEMxNi42NyAxOS4xIDE3LjU3IDIwIDE4LjY3IDIwSDIwQzIxLjExIDIwIDIyIDE5LjEgMjIgMThaTTE0LjY3IDE4VjZDMTQuNjcgNC45IDEzLjc3IDQgMTIuNjcgNEgxMS4zNEMxMC4yNCA0IDkuMzQgNC45IDkuMzQgNlYxOEM5LjM0IDE5LjEgMTAuMjQgMjAgMTEuMzQgMjBIMTIuNjdDMTMuNzcgMjAgMTQuNjcgMTkuMSAxNC42NyAxOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewWeek = createIcon('ViewWeek', [
  [
    'path',
    {
      d: 'M5.33 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H5.33C6.43 4 7.33 4.9 7.33 6V18C7.33 19.1 6.44 20 5.33 20ZM22 18V6C22 4.9 21.1 4 20 4H18.67C17.57 4 16.67 4.9 16.67 6V18C16.67 19.1 17.57 20 18.67 20H20C21.11 20 22 19.1 22 18ZM14.67 18V6C14.67 4.9 13.77 4 12.67 4H11.34C10.24 4 9.34 4.9 9.34 6V18C9.34 19.1 10.24 20 11.34 20H12.67C13.77 20 14.67 19.1 14.67 18Z',
      key: '1l9mer',
    },
  ],
]);

export default ViewWeek;
